module.exports = __webpack_public_path__ + "static/studio-04-56b28dcd7aadf43815c5c4c6b23f8e38.webp";